import { casinos } from '../../../mocks/casinos';

export default function ComparisonTable() {
  return (
    <section className="py-20 px-4 bg-gradient-to-r from-[#1a1a1f] via-[#242429] to-[#1a1a1f]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 animate-on-scroll opacity-0">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Сравнительная таблица live-казино</h2>
          <p className="text-gray-400">Детальное сравнение всех параметров</p>
        </div>

        <div className="overflow-x-auto animate-on-scroll opacity-0">
          <table className="w-full bg-[#1f1f24] rounded-2xl overflow-hidden">
            <thead>
              <tr className="bg-[#0a0a0f]">
                <th className="px-6 py-4 text-left text-[#d4af37] font-bold">Казино</th>
                <th className="px-6 py-4 text-left text-[#d4af37] font-bold">Количество live-игр</th>
                <th className="px-6 py-4 text-left text-[#d4af37] font-bold">Мин. ставка</th>
                <th className="px-6 py-4 text-left text-[#d4af37] font-bold">Язык дилеров</th>
                <th className="px-6 py-4 text-left text-[#d4af37] font-bold">Уникальные игры</th>
                <th className="px-6 py-4 text-center text-[#d4af37] font-bold">Мобильная версия</th>
              </tr>
            </thead>
            <tbody>
              {casinos.map((casino, index) => (
                <tr 
                  key={casino.id} 
                  className={`${index % 2 === 0 ? 'bg-[#242429]' : 'bg-[#1a1a1f]'} hover:bg-gradient-to-r hover:from-[#d4af37]/10 hover:to-transparent transition-all duration-300`}
                >
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <img src={casino.logo} alt={casino.name} className="w-10 h-10 rounded-full object-contain" />
                      <span className="font-bold">{casino.name}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-gray-300">{casino.liveGamesCount}</td>
                  <td className="px-6 py-4 text-gray-300">{casino.minBet}</td>
                  <td className="px-6 py-4 text-gray-300">{casino.dealerLanguages}</td>
                  <td className="px-6 py-4 text-gray-300 text-sm">{casino.uniqueGames}</td>
                  <td className="px-6 py-4 text-center">
                    {casino.mobileStream ? (
                      <i className="ri-check-line text-2xl text-[#2ecc71]"></i>
                    ) : (
                      <i className="ri-close-line text-2xl text-[#c41e3a]"></i>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 md:hidden space-y-4">
          {casinos.map((casino, index) => (
            <div key={casino.id} className="bg-[#242429] rounded-2xl p-6 animate-on-scroll opacity-0" style={{ animationDelay: `${index * 50}ms` }}>
              <div className="flex items-center gap-3 mb-4 pb-4 border-b border-gray-700">
                <img src={casino.logo} alt={casino.name} className="w-12 h-12 rounded-full object-contain" />
                <span className="font-bold text-xl">{casino.name}</span>
              </div>
              <div className="space-y-3">
                <div className="flex justify-between">
                  <span className="text-gray-400">Live-игр:</span>
                  <span className="font-semibold">{casino.liveGamesCount}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Мин. ставка:</span>
                  <span className="font-semibold">{casino.minBet}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Языки:</span>
                  <span className="font-semibold text-sm">{casino.dealerLanguages}</span>
                </div>
                <div className="flex justify-between items-start">
                  <span className="text-gray-400">Уникальные:</span>
                  <span className="font-semibold text-sm text-right max-w-[60%]">{casino.uniqueGames}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Мобильная:</span>
                  {casino.mobileStream ? (
                    <i className="ri-check-line text-xl text-[#2ecc71]"></i>
                  ) : (
                    <i className="ri-close-line text-xl text-[#c41e3a]"></i>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}